import { Container } from '@cgs/wge';
import { IconEnumerator } from '../../reels_engine/icon_enumerator';
import { SlotParams } from '../../reels_engine/slot_params';
import { T_IGameParams } from '../../type_definitions';

export class IconEnumeratorComponent {
  iconsEnumerator: IconEnumerator;
  constructor(container: Container) {
    console.log('load ' + this.constructor.name);
    const slotParams: SlotParams = container.resolve<SlotParams>(T_IGameParams);
    this.iconsEnumerator = new IconEnumerator(slotParams.reelsCount, slotParams.linesCount);
  }
}
